var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01 Icons/01 Small/lock-maintenance") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-Icons/01-Small/lock-maintenance",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uE2D1",
    transform: "translate(5.250000, 3.328125)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.67578125,5.72265625 L6.36328125,7.41015625 C6.62109375,7.62109375 6.87890625,7.62109375 7.13671875,7.41015625 L8.82421875,5.72265625 C8.94140625,5.60546875 9,5.46484375 9,5.30078125 L9,0.5546875 C9,0.34375 9.08203125,0.19140625 9.24609375,0.09765625 C9.38671875,-0.01953125 9.55078125,-0.03125 9.73828125,0.0625 C10.8632812,0.625 11.765625,1.43359375 12.4453125,2.48828125 C13.125,3.56640625 13.4765625,4.7734375 13.5,6.109375 C13.4765625,7.375 13.171875,8.51171875 12.5859375,9.51953125 C11.9765625,10.5507812 11.15625,11.359375 10.125,11.9453125 L10.125,16.234375 C10.1015625,16.703125 9.9375,17.1015625 9.6328125,17.4296875 C9.3046875,17.734375 8.90625,17.8984375 8.4375,17.921875 L5.0625,17.921875 C4.59375,17.8984375 4.1953125,17.734375 3.8671875,17.4296875 C3.5625,17.1015625 3.3984375,16.703125 3.375,16.234375 L3.375,11.9453125 C2.34375,11.359375 1.5234375,10.5507812 0.9140625,9.51953125 C0.328125,8.51171875 0.0234375,7.375 0,6.109375 C0.0234375,4.7734375 0.375,3.56640625 1.0546875,2.48828125 C1.734375,1.43359375 2.63671875,0.625 3.76171875,0.0625 C3.94921875,-0.03125 4.11328125,-0.01953125 4.25390625,0.09765625 C4.41796875,0.19140625 4.5,0.34375 4.5,0.5546875 L4.5,5.30078125 C4.5,5.46484375 4.55859375,5.60546875 4.67578125,5.72265625 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMaintenance);
export default __webpack_public_path__ + "static/media/ic-maintenance.6a9186a456191dfd28ba9f9b75df0ac9.svg";
export { ForwardRef as ReactComponent };